export const enum ThreadSendReceiveType {
  /** 送信スレッド */
  _1_SEND = 1,
  /** 受信スレッド */
  _2_RECEIVE,
}
